import { render, staticRenderFns } from "./SurveyGrid.vue?vue&type=template&id=358d2c3d&"
import script from "./SurveyGrid.vue?vue&type=script&lang=js&"
export * from "./SurveyGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataIterator } from 'vuetify/lib/components/VDataIterator';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataIterator,VRow})
